import { Component, OnInit, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/common/api-service/api.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  subscription: Subscription[] = [];

  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  // footer
  schoolAt1: string = '';
  schoolAt2: string = '';
  phoneNumber: string = '';
  email: string = '';
  footer = {
    id: '',
    siteid: '',
    title: '',
    keywords: '',
    description: '',
    col1: '',
    col2: '',
    col3: '',
    footer: '',
    banner: '',
    linkvideo: '',
    about: '',
    approved: '',
    lang: '',
  }

  //fanpage
  fanpage: any

  constructor(private api: ApiService, location: Location,
    private element: ElementRef, private router: Router,
    private sanitizer: DomSanitizer) {
    this.location = location;
    this.sidebarVisible = false;

  }

  ngOnInit() {
    // first load
    this.subscription.push(this.api.sendDataService.language$.subscribe(data => {
      this.getFooterWithSite();
    }));
  }

  /**
   * getFooterWithSite
   */
  getFooterWithSite() {
    // update view of news
    const param = {
      'siteid': 11,
      'lang': this.api.getLanguage()
    };

    this.subscription.push(this.api.excuteAllByWhat(param, '27').subscribe(result => {
      let data = result.data;
      if (result.status == true) {

        this.footer = data[0];
        this.fanpage = this.sanitizer.bypassSecurityTrustHtml(this.footer.col3);
        if (this.footer.about.search('&lt;p') >= 0) {
          this.footer.about = this.api.formatHtmlTag(this.footer.about);
        }
      } else {
        this.footer = null;
      }
    }));
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    body.classList.add('nav-open');

    this.sidebarVisible = true;
  };
  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    body.classList.remove('nav-open');
  };
  sidebarToggle() {
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName('body')[0];

    if (this.mobile_menu_visible == 1) {
      body.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function () {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        $toggle.classList.add('toggled');
      }, 430);

      var $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');


      if (body.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (body.classList.contains('off-canvas-sidebar')) {
        document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
      }

      setTimeout(function () {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = function () { //asign a function
        body.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        $layer.classList.remove('visible');
        setTimeout(function () {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }.bind(this);

      body.classList.add('nav-open');
      this.mobile_menu_visible = 1;

    }
  };

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

}
